import React from 'react';
import { FormattedMessage } from 'react-intl';

export const makeCalculationsRowsOtherCriteria = (treatmentData) => {
  const rows = [];

  // Process ecological integrity data
  if (treatmentData.ecologicalIntegrity && Array.isArray(treatmentData.ecologicalIntegrity)) {
    treatmentData.ecologicalIntegrity.forEach(item => {
      rows.push({
        criteriaAssessed: 'Ecological integrity',
        year: item.year,
        kbaCriteria: item.ecologicalIntegrity ? 'C' : '-'
      });
    });
  }

  // Process irreplaceability data
  if (treatmentData.irreplaceability && Array.isArray(treatmentData.irreplaceability)) {
    treatmentData.irreplaceability.forEach(item => {
      rows.push({
        criteriaAssessed: 'Irreplaceability',
        year: item.year,
        kbaCriteria: item.irreplaceability ? 'E' : '-'
      });
    });
  }

  return rows;
};

export const makeCalculationsColumnsOtherCriteria = () => {
  return [
    {
      id: 'criteriaAssessed',
      header: (
        <>
          <FormattedMessage id='criteriaAssessed' />
        </>
      ),
      accessorKey: 'criteriaAssessed',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'year',
      header: (
        <>
          <FormattedMessage id='year' />
        </>
      ),
      accessorKey: 'year',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'kbaCriteria',
      header: (
        <>
          <FormattedMessage id='kbaCriteria' />
        </>
      ),
      accessorKey: 'kbaCriteria',
      style: {
        width: '10%'
      },
      cell: ({ getValue }) => getValue()
    }
  ];
};